import { DialogContent, DialogTitle, Stack } from '@mui/material';
import { PromptGroupsList } from '../PromptGroupsList';
import { usePromptGroups } from '../../promptsLibrary/usePromptGroups';
import { useSelector } from 'react-redux';
import { selectPromptGroupsWithPrompts_deprecated } from '../../../../reducers/promptLibraryReducer';
import { CloseButton } from './CloseButton';
import { Button, Typography } from '@sweep-io/sweep-design';
import useSendBiEvent from '../../../../hooks/useSendBiEvent';
import { AI_AGENTS_EVENTS } from '../../../../services/events';

interface PromptGroupsViewProps {
  onClose: () => void;
}

export const PromptGroupsView = ({ onClose }: PromptGroupsViewProps) => {
  const { selectGroup, addEmptyPromptGroup__deprecated } = usePromptGroups();
  const promptGroups = useSelector(selectPromptGroupsWithPrompts_deprecated);
  const hasNewPromptGroupCard = !!promptGroups?.some((group) => group.id === '');
  const sendBiEvent = useSendBiEvent();

  const onNewCategoryClick = () => {
    sendBiEvent({ name: AI_AGENTS_EVENTS.promptsLibraryNewCategory });
    addEmptyPromptGroup__deprecated();
  };

  return (
    <>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h1">Prompts library</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            variant="secondary"
            startIconName="Plus"
            disabled={hasNewPromptGroupCard}
            onClick={onNewCategoryClick}
          >
            New category
          </Button>

          <CloseButton onClose={onClose} />
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ mt: 2, pb: 3 }}>
        <PromptGroupsList promptGroups={promptGroups ?? []} onPromptCardClick={selectGroup} />
      </DialogContent>
    </>
  );
};
